export default __webpack_public_path__ + "static/media/2.1207d72a.png";